export default __webpack_public_path__ + "static/media/background.frag.341a1760.glsl";